// Tax (BTS) tab. Lists this household's BTS engagements with each
// person's tax-specific revenue (annual fee or tax plan fee). Includes
// placeholders for the future TaxDome + ProConnect integrations.
//
// Phase C port of the legacy modal's BTSTab. snake_case fields.

import { EngagementsList, PlaceholderCard, EmptyState, AddServiceCTA, formatCurrency } from './_engagementsList';

const TIER_LABELS = {
  'tax-prep':       'Tax Prep',
  'tax-individual': 'Tax Prep (Individual)',
  'tax-business':   'Tax Prep (Business)',
  'business-package': 'Business Package',
  'tax-plan':       'Tax Plan',
  'bookkeeping':    'Bookkeeping',
  'total-wealth':   'Total Wealth',
};

export default function TaxTab({ members, people }) {
  const bts = members.filter(m => m.division === 'bts');
  const peopleById = Object.fromEntries(people.map(p => [p.id, p]));

  return (
    <div className="space-y-4">
      <div className="bg-white rounded-[4px] shadow-[0_2px_6px_rgba(0,0,0,0.07)] p-5">
        <div className="flex items-baseline justify-between mb-4">
          <div>
            <h2 className="text-[15px] font-bold text-navy">Tax (BTS) Engagements</h2>
            <p className="text-[11px] text-[#888] mt-0.5">
              {bts.length} {bts.length === 1 ? 'engagement' : 'engagements'}
            </p>
          </div>
          <AddServiceCTA division="bts" label="+ Add Tax Service" />
        </div>

        {bts.length === 0 ? (
          <EmptyState label="No BTS service for this household." />
        ) : (
          <EngagementsList
            engagements={bts}
            peopleById={peopleById}
            renderDetail={(e) => (
              <>
                <DetailChip label="Tier" value={TIER_LABELS[e.service_tier] || e.service_tier || '—'} />
                {Number(e.tax_plan_fee) > 0 && (
                  <DetailChip label="Tax plan" value={formatCurrency(e.tax_plan_fee)} accent />
                )}
                {Number(e.annual_revenue) > 0 && (
                  <DetailChip label="Annual" value={`${formatCurrency(e.annual_revenue)}/yr`} />
                )}
                {Number(e.monthly_revenue) > 0 && (
                  <DetailChip label="Monthly" value={`${formatCurrency(e.monthly_revenue)}/mo`} />
                )}
              </>
            )}
          />
        )}
      </div>

      <div className="grid grid-cols-2 gap-3">
        <PlaceholderCard
          title="TaxDome"
          body="Active jobs, document requests, and engagement status will land here once the TaxDome integration is wired up."
        />
        <PlaceholderCard
          title="ProConnect"
          body="Filing status, refund / balance due, and prior-year returns will land here after the ProConnect feed is connected."
        />
      </div>
    </div>
  );
}

function DetailChip({ label, value, accent }) {
  return (
    <span className="inline-flex items-baseline gap-1.5 text-[11px]">
      <span className="text-[#888] uppercase tracking-wider text-[9px]">{label}</span>
      <span className={accent ? 'text-deep-teal font-bold' : 'text-navy font-bold'}>{value}</span>
    </span>
  );
}
